<template>
  <Component :is="tag" v-if="caption || copyright" class="text-xs">
    <div v-if="caption" class="font-bold">
      {{ caption }}
    </div>
    <div v-if="copyright">&copy; {{ copyright }}</div>
  </Component>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    caption?: string
    copyright?: string
    tag?: string
  }>(),
  {
    caption: '',
    copyright: '',
    tag: 'figcaption',
  },
)
</script>
